import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const WhoweAreService = {
  getList: async () => {
    const response = await apiService.get("/maintainance/who-we-are");

    return response.data;
  },
  
  getbySlug: async (slug) => {
    const response = await apiService.get(
      `/maintainance/who-we-are/by-slug/${slug}`
    );
    return response.data;
  },
};

export default WhoweAreService;